import {FbFormObject} from '../class/fb_form_object';

export class UserStore extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'username', label: 'User', visible: true, noclick: false, disable_ripple: true},
            {id: 'sc_username', label: 'SC Username', visible: true, noclick: false, disable_ripple: true},
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'User',
                class: 'card card-1 padding',
                field_class: '',
                fields: [
                    {
                        type: 'text',
                        name: 'username',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'sc_username',
                        disabled: true
                    }
                ]
            }
        ];


        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['user'] = this.storeService.getStore('user');
            this.main_store = this.stores['user'];

            const stores = [];
            if (!this.stores['user'].isLoaded()) {
                stores.push(this.stores['user'].loadStore(this.filter));
            }

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
                username: 0,
                sc_username: ''
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        super.setSelectboxes();
    }
}
